var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sweet-modal',{ref:"modal",attrs:{"title":_vm.title,"width":"800","blocking":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }